<div class="product-single" [ngClass]="{ badges: hasBadge, normal: !wide, wide: wide }">
  <a>
    @if (hasBadge) {
      <div class="flag">
        @for (badge of product | badges: 'flag' : excludeBadges; track badge) {
          <em [class]="badge.badgeType">
            {{ badge.value ? '-' + badge.value + '%' : null }}
          </em>
        }
      </div>
    }
    <dl
      [ngClass]="{
        'out-of-stock': product.productStatus === PRODUCT_STATUS.OUT_OF_STOCK,
      }"
      [class]="i18n.language"
    >
      <dt (click)="onSelectProduct(product)">
        <mat-checkbox
          class="checkbox"
          [checked]="isChecked"
          (change)="onSelectProduct(product)"
          (click)="onSelectProduct(product)"
        ></mat-checkbox>
        @if (numberTag) {
          <span class="text-number">{{ numberTag }}</span>
        }
        <div>
          <img src="{{ product.images[0]?.endpoint }}" draggable="false" />
        </div>
      </dt>
      <dd (click)="goToProductDetail()">
        <p>[{{ product.brand.englishName }}]</p>
        <p>
          <span>
            {{ product.englishName }}
          </span>
        </p>
        @if ((product?.mapperSaleProducts)[0].productOption.reviewDetails?.ratingAvg) {
          <div class="review-rating">
            <div style="align-items: center; z-index: 1">
              <ngx-stars
                [readonly]="true"
                [size]="1"
                [maxStars]="5"
                [initialStars]="(product?.mapperSaleProducts)[0].productOption.reviewDetails?.ratingAvg"
                [color]="'#e04fa3'"
              >
              </ngx-stars>
              <!-- <span style="font-weight: bold; font-size: 20px">Rating is {{ ratingDisplay }} out of 5</span> -->
            </div>
            <div style="display: flex; align-items: center">
              <span class="rating-total">{{
                (product?.mapperSaleProducts)[0].productOption.reviewDetails.ratingAvg | number: '1.2-2'
              }}</span>
              <span class="review-count">
                ({{ (product?.mapperSaleProducts)[0].productOption.reviewDetails.reviewCount | number }})</span
              >
            </div>
          </div>
        }
        @if (!(product?.mapperSaleProducts)[0].productOption.finalSaleSupplyPrice) {
          @if ((product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
            <del
              >MSRP ${{
                product.minFixedMsrpPriceUSD !== product.maxFixedMsrpPriceUSD
                  ? (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2')
              }}</del
            >
          }
          @if (!(product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
            <del
              >MSRP ${{
                product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                  ? (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2')
              }}</del
            >
          }
          <p>
            ${{
              product.minSalePriceUSD !== product.maxSalePriceUSD
                ? (product.minSalePriceUSD | currency: 'USD' : '' : '0.2') + '~'
                : (product.minSalePriceUSD | currency: 'USD' : '' : '0.2')
            }}<span class="supply-rate">{{
              product.minSupplyRate !== product.maxSupplyRate
                ? (product.minSupplyRate | salesRate) + '%~' + (product.maxSupplyRate | salesRate) + '%'
                : (product.minSupplyRate | salesRate) + '%'
            }}</span>
          </p>
        }
        @if ((product?.mapperSaleProducts)[0].productOption.finalSaleSupplyPrice) {
          @if ((product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
            <del
              >MSRP ${{
                product.minFixedMsrpPriceUSD !== product.maxFixedMsrpPriceUSD
                  ? (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minFixedMsrpPriceUSD | currency: 'USD' : '' : '0.2')
              }}</del
            >
          }
          @if (!(product?.mapperSaleProducts)[0].productOption.isFixedMsrp) {
            <del
              >MSRP ${{
                product.minMsrpPriceUSD !== product.maxMsrpPriceUSD
                  ? (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                  : (product.minMsrpPriceUSD | currency: 'USD' : '' : '0.2')
              }}</del
            >
          }
          <del style="padding-left: 5px">
            ${{
              product.minSalePriceUSD !== product.maxSalePriceUSD
                ? (product.minSalePriceUSD | currency: 'USD' : '' : '0.2') + '~'
                : (product.minSalePriceUSD | currency: 'USD' : '' : '0.2')
            }}<span style="padding-left: 5px">
              <del style="color: #e04fa3 !important">
                {{
                  product.minSupplyRate !== product.maxSupplyRate
                    ? (product.minSupplyRate | salesRate) + '%~' + (product.maxSupplyRate | salesRate) + '%'
                    : (product.minSupplyRate | salesRate) + '%'
                }}
              </del>
            </span>
          </del>
          <p>
            ${{
              product.minFinalSaleSupplyPriceUSD !== product.maxFinalSaleSupplyPriceUSD
                ? (product.minFinalSaleSupplyPriceUSD | currency: 'USD' : '' : '0.2') + '~'
                : (product.maxFinalSaleSupplyPriceUSD | currency: 'USD' : '' : '0.2')
            }}<span class="supply-rate">{{
              product.minFinalSaleSupplyRate !== product.maxFinalSaleSupplyRate
                ? (product.minFinalSaleSupplyRate | salesRate) +
                  '%~' +
                  (product.maxFinalSaleSupplyRate | salesRate) +
                  '%'
                : (product.minFinalSaleSupplyRate | salesRate) + '%'
            }}</span>
          </p>
        }
        <app-product-stock-badges [product]="product" />
        <!-- <div class="badge" *ngIf="hasBadge">
            <ng-container *ngFor="let badge of product | badges: 'badge':excludeBadges">
              <span [class]="badge.badgeType">{{ badge.badgeType | commonCode: 'BADGE_TYPE' }}</span>
            </ng-container>
          </div> -->
      </dd>
    </dl>
  </a>

  @if (product.productStatus !== PRODUCT_STATUS.OUT_OF_STOCK) {
    <a (click)="addToCartModal()" class="button-cart"></a>
  }
</div>
